import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ISalesFunnel } from '@user/store/salesFunnel'

type Props = {
  name: string
}

export function useHandlers(props: Props) {
  const { name } = props
  const { setValues } = useFormikContext<IAddOpportunityFormModel>()

  const handelChange = useCallback((value: ISalesFunnel | null) => {
    setValues((model) => ({
      ...model,
      [name]: value?.id ?? '',
      opportunityStageId: '',
      opportunityStageName: '',
      opportunityStageClosedLostIdTemp: '',
      closedLostReasonId: '',
      closedLostCustomReason: '',
    }))
  }, [])

  return {
    handelChange,
  }
}
